export const PAGE_TYPES = {
  COMPANY: '_company',
  FRANCHISE: '_franchise',
  EMPTY: '_empty'
}